import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { assignedSlotNames } from "common/slot";
import { LabelsAdapter } from "common/labelsAdapter";
import { MediaQueryAdapter, MEDIA_QUERIES } from "common/mediaQueryAdapter";
import { EffectAdapter } from "common/effectAdapter";
import { attrToBool } from "common/helpers";
import { DEFAULT_SPRITE } from "tds/icon";

var data$9 = { back: "Zurück", filters_toggle: "Filter" };
data$9.back;
data$9.filters_toggle;

var data$8 = { back: "Back", filters_toggle: "Filters" };
data$8.back;
data$8.filters_toggle;

var data$7 = { back: "Atrás", filters_toggle: "Filtros" };
data$7.back;
data$7.filters_toggle;

var data$6 = { back: "Atrás", filters_toggle: "Filtros" };
data$6.back;
data$6.filters_toggle;

var data$5 = { back: "Précédent", filters_toggle: "Filtres" };
data$5.back;
data$5.filters_toggle;

var data$4 = { back: "Indietro", filters_toggle: "Filtri" };
data$4.back;
data$4.filters_toggle;

var data$3 = { back: "戻る", filters_toggle: "検索条件" };
data$3.back;
data$3.filters_toggle;

var data$2 = { back: "뒤로", filters_toggle: "필터" };
data$2.back;
data$2.filters_toggle;

var data$1 = { back: "Voltar", filters_toggle: "Filtros" };
data$1.back;
data$1.filters_toggle;

var data = { back: "返回", filters_toggle: "筛选器" };
data.back;
data.filters_toggle;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class pageHeader extends LightningElement {
  @api heading = null;
  @api headingImageSrc = null;
  @api headingImageAltText = null;
  @api headingImageVariant = null;
  @api headingIconSprite = DEFAULT_SPRITE;
  @api headingIconSymbol = null;
  @api subHeading = null;
  @api description = null;
  @api descriptionHtml = null;
  @api backButtonHref = null;
  @api searchLabel = null;
  @api searchValue = null;
  @api searchDisabled = false;
  @api searchBusy = false;
  @api primaryActionLabel = null;
  @api primaryActionIconSymbol = null;
  @api primaryActionIconSprite = DEFAULT_SPRITE;
  @api primaryActionVariant = "brand";
  @api pretitle = null;
  @api pretitleHtml = null;
  @api pretitleHtmlConfig = null;
  @api minSearchChars = null;
  isStacked = false;
  isCollapsible = true;
  isCollapseDisabled = false;
  closed = false;
  slots = "";
  height = null;
  @api get collapsible() {
    return this.isCollapsible && this.slots.includes("filters");
  }
  set collapsible(newValue) {
    this.isCollapsible = attrToBool(newValue);
  }
  @api get open() {
    return !this.closed;
  }
  set open(newValue) {
    this.closed = !attrToBool(newValue);
  }
  @api get collapseDisabled() {
    return this.isCollapseDisabled;
  }
  set collapseDisabled(newValue) {
    this.isCollapseDisabled = attrToBool(newValue);
  }
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = null;
  @wire(MediaQueryAdapter, {
    media: MEDIA_QUERIES.md,
  })
  onMatch({ matches }) {
    this.isStacked = matches;
  }
  get hasPretitle() {
    return !!this.pretitle || !!this.pretitleHtml;
  }
  get hasSearch() {
    return !!this.searchLabel || !!this.searchValue;
  }
  get hasHeader() {
    return (
      this.hasSearch ||
      this.primaryActionLabel ||
      this.heading ||
      this.subHeading ||
      this.description ||
      this.descriptionHtml
    );
  }
  get isSearchDisabled() {
    return attrToBool(this.searchDisabled);
  }
  get isSearchBusy() {
    return attrToBool(this.searchBusy);
  }
  get headingImageClass() {
    return classNames(
      "heading__image",
      this.headingImageVariant && `heading__image--${this.headingImageVariant}`
    );
  }
  get filterSection() {
    return this.template.querySelector(".filters");
  }
  @wire(EffectAdapter, {
    closed: "$closed",
  })
  onFilterData() {
    if (this.closed && this.filterSection) {
      this.collapseFiltersNoTransition(this.filterSection);
    }
    if (!this.closed && this.filterSection) {
      this.expandFilters(this.filterSection);
    }
  }
  handleSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }
  handleToggleFilters(e) {
    e.preventDefault();
    if (this.isCollapseDisabled) return;
    this.open = !this.open;
    if (this.open) {
      this.expandFilters(this.filterSection);
      this.dispatchEvent(new CustomEvent("requestopen"));
    } else {
      this.collapseFilters(this.filterSection);
      this.dispatchEvent(new CustomEvent("requestclose"));
    }
  }
  handlePrimaryActionClick(e) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent("primaryaction"));
  }
  handleSearch(e) {
    this.dispatchEvent(new CustomEvent("search", e));
  }
  collapseFilters(element) {
    let sectionHeight = element.offsetHeight;
    this.height = element.offsetHeight;

    // temporarily disable all css transitions
    let elementTransition = element.style.transition;
    element.style.transition = "";

    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
      element.style.height = sectionHeight + "px";
      element.style.transition = elementTransition;

      // on the next frame have the element transition to height: 0
      requestAnimationFrame(() => {
        element.style.height = 0 + "px";
      });
    });
    element.setAttribute("aria-hidden", "true");
  }
  collapseFiltersNoTransition(element) {
    this.height = element.offsetHeight;
    let elementTransition = element.style.transition;
    element.style.transition = "";

    // Seems to only collapse properly on future clicks when wrapped. Causes brief flicker
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        element.style.height = 0 + "px";
        element.style.transition = elementTransition;
      });
    });
  }
  expandFilters(element) {
    element.style.height = this.height + "px";
    // when the next css transition finishes
    element.addEventListener("transitionend", function resetHeight() {
      // remove event listener so it only gets triggered once
      element.removeEventListener("transitionend", resetHeight);
      element.style.height = "auto";
    });
    element.setAttribute("aria-hidden", "false");
  }
}

export default pageHeader;
